// @ts-check

/** @file Defines the local Timelog shell and associations. */

import TimelogBase from "../model-bases/timelog.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"
import {PROJECT_REPLICA_SYNC_DECLARATION} from "../database/project-replica-sync.js"

/** Basic timelog row in the local application replica. */
const TimelogModel = projectReplicaModel(TimelogBase)

export default TimelogModel

TimelogModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TimelogModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TimelogModel.sync = PROJECT_REPLICA_SYNC_DECLARATION
TimelogModel.belongsTo("task")
